 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import CONTENTCONTENT0006 from '@/components/content/content0006'
 import CONTENTCONTENT0007 from '@/components/content/content0007'
 import CONTENTCONTENT0017 from '@/components/content/content0017'
 import CONTENTCONTENT0024 from '@/components/content/content0024'
 import CONTENTCONTENT0026 from '@/components/content/content0026'
 import CONTENTCONTENT0027 from '@/components/content/content0027'
 import CONTENTCONTENT0034 from '@/components/content/content0034'
 import CONTENTCONTENT0039 from '@/components/content/content0039'
 import CONTENTCONTENT0040 from '@/components/content/content0040'
 import CONTENTCONTENT0045 from '@/components/content/content0045'
 import CONTENTCONTENT0047 from '@/components/content/content0047'
 import CONTENTCONTENT0048 from '@/components/content/content0048'
 import CONTENTCONTENT0049 from '@/components/content/content0049'
 import CONTENTCONTENT0053 from '@/components/content/content0053'
 import CONTENTCONTENT0057 from '@/components/content/content0057'
 import CONTENTCONTENT0058 from '@/components/content/content0058'
 import CONTENTCONTENT0063 from '@/components/content/content0063'
 import CONTENTCONTENT0081 from '@/components/content/content0081'
 import CONTENTCONTENT0097 from '@/components/content/content0097'
 import CONTENTCONTENT0104 from '@/components/content/content0104'
 import CONTENTCONTENT0115 from '@/components/content/content0115'
 import CONTENTCONTENT0118 from '@/components/content/content0118'
 import CONTENTCONTENT0136 from '@/components/content/content0136'
 import CONTENTCONTENT0139 from '@/components/content/content0139'
 import CONTENTCONTENT0147 from '@/components/content/content0147'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/content/content0006",
 			"name" : "content/content0006",
 			"component" : CONTENTCONTENT0006
 		},
 		{
 			"path" : "/content/content0007",
 			"name" : "content/content0007",
 			"component" : CONTENTCONTENT0007
 		},
 		{
 			"path" : "/content/content0017",
 			"name" : "content/content0017",
 			"component" : CONTENTCONTENT0017
 		},
 		{
 			"path" : "/content/content0024",
 			"name" : "content/content0024",
 			"component" : CONTENTCONTENT0024
 		},
 		{
 			"path" : "/content/content0026",
 			"name" : "content/content0026",
 			"component" : CONTENTCONTENT0026
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js